import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import i18n from "@/plugins/i18n.js";

// Import components
const Home = () => import("@/views/Landing.vue");
const LiveData = () => import("@/views/Home.vue");

const AdminDashboard = () => import("@/views/AdminDashboard.vue");

const Company = () => import("@/views/company/Company.vue");
const CompanyUsers = () => import("@/components/company/Users.vue");
const CompanyEdit = () => import("@/components/company/Edit.vue");
const CompanyCreate = () => import("@/components/company/Create.vue");
const CreateUser = () => import("@/components/company/CreateUser.vue");
const CompanyApps = () => import("@/components/company/Applications.vue");

const ConnectorView = () => import("@/views/ConnectorView.vue");
const ConnectorShow = () => import("@/components/connectors/Show.vue");
const ConnectorCreate = () => import("@/components/connectors/Create.vue");
const ConnectorEdit = () => import("@/components/connectors/Edit.vue");

const UserCompanyRegister = () => import("@/components/user/Register");
const EditUser = () => import("@/components/user/Detail");

const ForgotPassword = () => import("@/views/ForgotPassword.vue");
const ForgotPasswordComponent = () =>
  import("@/components/password/ForgotPasswordComponent.vue");
const NewPassword = () => import("@/components/password/NewPassword.vue");

const Device = () => import("@/views/Device.vue");
const DeviceField = () => import("@/views/DeviceField.vue");

const DeviceList = () => import("@/components/device/ListDevice.vue");
const DeviceDetails = () => import("@/components/device/DeviceDetails.vue");
const DeviceFieldCreate = () =>
  import("@/components/device/CreateDeviceField.vue");
const DeviceFieldUpdate = () =>
  import("@/components/device/UpdateDeviceField.vue");

const DevicePool = () => import("@/components/device/DevicePool.vue");

const ListDeviceField = () =>
  import("@/components/device/ListDevicesFields.vue");

const Login = () => import("@/views/Login.vue");
const Register = () => import("@/views/Register.vue");
const Logout = () => import("@/views/Logout.vue");

const Contact = () => import("@/views/Contact.vue");

import { Roles } from "@/_helpers/Role";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: { authorize: [] }
    },

    {
      path: "/live",
      component: LiveData
    },

    {
      path: "/pool",
      component: Device,
      children: [
        {
          path: "",
          component: DevicePool,
          meta: { authorize: Roles.AdminOrCompanyAdmin }
        }
      ]
    },

    {
      path: "/device",
      component: Device,
      children: [
        {
          path: "",
          component: DeviceList,
          meta: { authorize: Roles.CompanyOrUser }
        },

        {
          path: "detail/:id",
          component: DeviceDetails,
          meta: { authorize: Roles.CompanyOrUser }
        }
      ]
    },

    {
      path: "/connectors",
      component: ConnectorView,
      children: [
        {
          path: "",
          component: ConnectorShow,
          meta: { authorize: Roles.AdminOrCompanyAdmin }
        },
        {
          path: "create",
          component: ConnectorCreate,
          meta: { authorize: Roles.AdminOrCompanyAdmin }
        },
        {
          path: "edit/:id",
          component: ConnectorEdit,
          meta: { authorize: Roles.AdminOrCompanyAdmin }
        }
      ]
    },

    {
      path: "/device/fields",
      component: DeviceField,
      children: [
        {
          path: "",
          component: ListDeviceField,
          meta: { authorize: Roles.CompanyOrUser }
        },

        {
          path: "create",
          component: DeviceFieldCreate,
          meta: { authorize: Roles.CompanyOrUser }
        },

        {
          path: "create/:id",
          component: DeviceFieldCreate,
          meta: { authorize: Roles.CompanyOrUser }
        },

        {
          path: "update/:id",
          component: DeviceFieldUpdate,
          meta: { authorize: Roles.CompanyOrUser }
        }
      ]
    },

    {
      path: "/company",
      component: Company,
      children: [
        {
          path: "",
          component: CompanyUsers,
          meta: { authorize: Roles.CompanyOrUser }
        },
        {
          path: "edit",
          component: CompanyEdit,
          meta: { authorize: Roles.AdminOrCompanyAdmin }
        },
        {
          path: "create",
          component: CompanyCreate,
          meta: { authorize: Roles.Admin }
        },
        {
          path: "applications",
          component: CompanyApps,
          meta: { authorize: Roles.CompanyOrUser }
        },
        {
          path: "usercreate",
          component: CreateUser,
          meta: { authorize: Roles.AdminOrCompanyAdmin }
        },
        {
          path: "user/:id",
          component: EditUser,
          meta: { authorize: Roles.CompanyOrUser }
        }
      ]
    },

    {
      path: "/forgot",
      component: ForgotPassword,
      children: [
        {
          path: "",
          component: ForgotPasswordComponent
        },
        {
          path: ":id",
          component: NewPassword
        }
      ]
    },

    {
      path: "/superadmin",
      component: AdminDashboard,
      meta: { authorize: Roles.SuperAdmin }
    },

    {
      path: "/register",
      component: Register,
      children: [
        {
          path: "",
          component: UserCompanyRegister
        }
      ]
    },

    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/logout",
      name: "Logout",
      component: Logout
    },

    {
      path: "/contact",
      name: "Contact",
      component: Contact
    }
  ],

  duplicateNavigationPolicy: "reload"
});

router.beforeEach((to, from, next) => {
  if (
    store.state.languages !== undefined &&
    store.state.languages.language &&
    store.state.languages.language !== i18n.locale
  ) {
    i18n.locale = store.state.languages.language;
    next();
  } else if (
    store.state.languages === undefined ||
    !store.state.languages.language
  ) {
    store
      .dispatch("languages/setLanguage", navigator.languages, { root: true })
      .then(() => {
        i18n.locale = store.state.languages.language;
        next();
      });
  }

  if (to.meta.authorize && to.meta.authorize.length > 0) {
    var role = store.state.users.currentUser.role;

    if (!role) next({ path: "/login" });

    if (to.meta.authorize.includes(role)) {
      next();
    } else {
      next({ path: "/" });
    }
  }

  next();
});

export default router;
